import * as React from 'react'
import { cn } from '@/lib/utils'

const labelClassName =
  'font-sans text-label font-medium uppercase tracking-[0.12em] text-ink leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'

const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn(labelClassName, className)} {...props} />
  ),
)
Label.displayName = 'Label'

export { Label }
